import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { styled } from "styled-components";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "./../../../component/atoms/text/pretendardText";
import SearchBar from "./../../../component/atoms/input/searchBar";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import RedBtn from "./../../../component/atoms/button/redBtn";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import EventBtn from "./../../../component/atoms/button/eventBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Td from "./../../../component/atoms/layout/table/td";
import TableText from "./../../../component/atoms/text/table/tableText";

import Sidebar from "../../../component/organisms/sidebar";
import Header from "../../../component/organisms/header";
import SubSideBar from "../../../component/organisms/subSideBar";

import TableCount from "./../../../component/molecules/tableCount";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import Pagination from "./../../../component/molecules/pagination";

import Modal from "./../../../component/templates/Modal";

import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import scrollToTop from "../../../util/scrollToTop";
import { route } from "./../../../router/route";
import VuApi from "../../../api/vu.api";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Empty from "../../../component/molecules/empty";
import moment from "moment";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const KnowledgeVu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.knowledge_vu)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const categoryList = [
    { title: "제디피트 본캐", value: "FIRST" },
    { title: "제디피트 부캐", value: "SECOND" },
    { title: "제디피트 유튜브", value: "YOUTUBE" },
    { title: "라이팅크루 블로그", value: "BLOG" },
    { title: "라이팅크루 유튜브", value: "YOUTUBE_CREW" },
  ];

  const [selectedCategory, setSelectedCategory] = useState("");
  const [keyword, setKeyword] = useState("");
  const [activationFilter, setActivationFilter] = useState(true);

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setSelectedCategory(
      searchParams.get("category") ? searchParams.get("category") : ""
    );
    setActivationFilter(
      searchParams.get("activation") === "false" ? false : true
    );

    getVuList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [vuList, setVuList] = useState([]);

  const getVuList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
        activation: "Active",
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      if (
        searchParams.get("category") &&
        searchParams.get("category") !== "all"
      ) {
        data.vuType = searchParams.get("category");
      }

      if (searchParams.get("activation") === "false") {
        data.activation = "Inactive";
      }

      const response = (await VuApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
        };
      });

      setVuList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (vuList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = vuList.every((item) => idsInArray1.has(item.id));

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, vuList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      let delIds = checkedListStorage.map((item) => item.id);

      const data = {
        ids: delIds,
        allFlag: false,
      };

      await VuApi.delete(data);

      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);

      navigate(
        `${route.knowledge_vu}?page=1&category=${selectedCategory}&keyword=${keyword}&activation=${activationFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 활성 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(false);

  const activationChangeFunc = async (value) => {
    try {
      const data = {
        activation: value,
      };

      for (let i = 0; i < checkedListStorage.length; i++) {
        await VuApi.updateActivation(checkedListStorage[i].id, data);
      }

      sessionStorageInit();
      toast(toastMsg.update);
      getVuList();

      navigate(
        `${route.knowledge_vu}?page=1&category=${selectedCategory}&keyword=${keyword}&activation=${activationFilter}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="카테고리">
          <SubSideBarItem
            selected={selectedCategory === "all" || selectedCategory == ""}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=all&keyword=&activation=`
              );
            }}
          >
            전체
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedCategory === "FIRST"}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=FIRST&keyword=&activation=`
              );
            }}
          >
            제디피트 본캐
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedCategory === "SECOND"}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=SECOND&keyword=&activation=`
              );
            }}
          >
            제디피트 부캐
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedCategory === "YOUTUBE"}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=YOUTUBE&keyword=&activation=`
              );
            }}
          >
            제디피트 유튜브
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedCategory === "BLOG"}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=BLOG&keyword=&activation=`
              );
            }}
          >
            라이팅크루 블로그
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedCategory === "YOUTUBE_CREW"}
            onClick={() => {
              navigate(
                `${route.knowledge_vu}?page=1&category=YOUTUBE_CREW&keyword=&activation=`
              );
            }}
          >
            라이팅크루 유튜브
          </SubSideBarItem>
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>Vu:관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"게시글"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"제목, 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.knowledge_vu}?page=1&category=${selectedCategory}&keyword=${keyword}&activation=`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.knowledge_vu}?page=1&category=${selectedCategory}&keyword=${keyword}&activation=`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              {isWriteAuthority && (
                <EventBtn
                  text={"Vu:추가하기"}
                  onClick={() => {
                    navigate(route.knowledge_vu_create);
                    scrollToTop();
                  }}
                />
              )}
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              {activationFilter ? (
                <GrayBtn
                  onClick={() => {
                    activationChangeFunc(false);
                  }}
                >
                  게시글 숨기기
                </GrayBtn>
              ) : (
                <GrayBtn
                  onClick={() => {
                    activationChangeFunc(true);
                  }}
                >
                  게시글 숨김 풀기
                </GrayBtn>
              )}

              <RedBtn
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                삭제
              </RedBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="44px" />
              {/* 제목 */}
              <col width="401px" />
              {/* 카테고리 */}
              <col width="160px" />
              {/* 등록일 */}
              <col width="140px" />
              {/* 조회수 */}
              <col width="109px" />
              {/* 상태*/}
              <col width="134px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...vuList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          vuList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    제목
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    카테고리
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    등록일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    조회수
                  </TableText>
                </Th>
                <Th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                    <img
                      className={filterOpen === true ? "rotate" : "rotate-back"}
                      src="/assets/admin/icons/ico_arrow_down.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setFilterOpen(!filterOpen);
                      }}
                      alt="필터 펼치기/접기"
                    />
                    {filterOpen && (
                      <FilterWrapper>
                        <FilterTextWrapper>
                          <FilterText
                            onClick={() => {
                              navigate(
                                `${
                                  route.knowledge_vu
                                }?page=1&category=${selectedCategory}&keyword=${keyword}&activation=${true}`
                              );

                              setFilterOpen(false);
                            }}
                          >
                            활성
                            {activationFilter ? (
                              <img
                                src="/assets/admin/icons/ico_selectbox_checked.svg"
                                alt="선택됨"
                              />
                            ) : null}
                          </FilterText>
                        </FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            navigate(
                              `${
                                route.knowledge_vu
                              }?page=1&category=${selectedCategory}&keyword=${keyword}&activation=${false}`
                            );

                            setFilterOpen(false);
                          }}
                        >
                          숨김
                          {activationFilter ? null : (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterWrapper>
                    )}
                  </div>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {vuList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "59px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    {/* 제목 */}
                    <Td>
                      <TableText
                        onClick={() => {
                          navigate(`${route.knowledge_vu_edit}/${item.id}`);
                          scrollToTop();
                        }}
                        style={{
                          maxWidth: "278px",
                          cursor: "pointer",
                        }}
                      >
                        {item.title}
                      </TableText>
                    </Td>
                    {/* 카테고리 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "130px",
                        }}
                      >
                        {
                          categoryList.find(
                            (item02) => item02.value === item.vuType
                          )?.title
                        }
                      </TableText>
                    </Td>
                    {/* 등록일 */}
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    {/* 조회수 */}
                    <Td>
                      <TableText>{item.viewCount}</TableText>
                    </Td>
                    {/* 상태 */}
                    <Td>
                      <TableText
                        style={{
                          color: `${item.activation ? "#aaa" : "#cf6679"}`,
                        }}
                      >
                        {item.activation ? "활성" : "숨김"}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {vuList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.knowledge_vu}
            queryString={`category=${selectedCategory}&keyword=${keyword}&activation=${activationFilter}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default KnowledgeVu;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;
